import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class AddTemplateService {

    constructor(
        private http: HttpClient
    ) { }

    /**
     * Get templates
     */
    index(filter) {
        return this.http.post<any>('api_endpoint' + '/template/get-templates', { filter });
    }
}
